const keen = {
    projectId: '5b80612fc9e77c00014ec592',
    readKey: '3A322EC62B3908AB47F9939C56FFCBD5AB939FC4CC132F029D4A4D8A939FC059209DE9BE00F24658A62BD0F82F40CCE7783C5660585C522BA434938CA386CE4C00B03F7B4CAFC833C22CFF1AC21CADF5F2CBA44513E3B8B3621D343E16C159FA'
}

module.exports = {
    keen
}